import React from 'react'

import type {ContextUsage} from './omicsContextUsage'
import {formatContextTokenCount} from './omicsContextUsage'

export interface OmicsContextPopoverProps {
  usage: ContextUsage
  onClose: () => void
}

export const OmicsContextPopover: React.FC<OmicsContextPopoverProps> = ({usage, onClose}) => {
  return (
    <div
      className='omics-context-popover'
      role='dialog'
      aria-label='Context window usage'
    >
      <div className='omics-context-popover__header'>
        <span className='omics-context-popover__title'>Context Window</span>
        <button
          type='button'
          className='omics-context-popover__close'
          onClick={onClose}
          aria-label='Close'
        >
          <i className='fas fa-xmark' aria-hidden />
        </button>
      </div>
      <div className='omics-context-popover__body'>
        <div className='omics-context-popover__percent'>{usage.percent}% used</div>
        <div className='omics-context-popover__detail'>
          {formatContextTokenCount(usage.usedTokens)} / {formatContextTokenCount(usage.maxTokens)} tokens
        </div>
      </div>
    </div>
  )
}
